import script from "./reset-password.vue?vue&type=script&setup=true&lang=ts"
export * from "./reset-password.vue?vue&type=script&setup=true&lang=ts"

import "./reset-password.vue?vue&type=style&index=0&id=d6796ff2&scoped=true&lang=css"

import exportComponent from "/tmp/workspace/b-client-workspace_release_3.0.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6796ff2"]])

export default __exports__